// "Editar cuenta" del estudiante, compartido por admin, asesoras y afiliados
// para que no vuelvan a desfasarse. Es el mismo editor que tenía admin
// (pages/administrador/modificar-estudiante): mismos campos, pestañas y textos.
// Cada pantalla solo decide qué pestañas muestra.
import React, { Suspense } from 'react';
import { Box, Text, Button, Tabs, TabList, TabPanels, Tab, TabPanel } from '@chakra-ui/react';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import { Link, useNavigate } from 'react-router-dom';
import useSWR from 'swr';

import Loading from 'components/loading/Loading';
import getStudent from 'api/administrador/student/getStudent';
import PrincipalData from './PrincipalData';
import Identity from './Identity';
import ParentsInfo from './ParentsInfo';

const BasicInfo = React.lazy(() => import('./BasicInfo'));

export const ALL_SECTIONS = ['principal', 'basic', 'identity', 'parents'];

const TITLES = {
  principal: 'Datos Principales',
  basic: 'Información Básica',
  identity: 'Documento Personal',
  parents: 'Informacion de Acudientes',
};

export default function StudentProfileEditor({ studentId, backTo, sections = ALL_SECTIONS, basicVariant = 'full' }) {
  const navigate = useNavigate();
  const { data: student, mutate } = useSWR(
    {
      student: studentId,
      type: 'getInfoStudentAdmin',
    },
    getStudent,
    { revalidateOnFocus: false }
  );

  if (!student) return <Loading />;

  const backButton = (
    <Button variant="outline" colorScheme="messenger" size="sm" onClick={backTo ? undefined : () => navigate(-1)}>
      <ChevronLeftIcon /> Atrás
    </Button>
  );

  const render = (section) => {
    if (section === 'principal') return <PrincipalData student={student} mutate={mutate} />;
    if (section === 'basic') return <BasicInfo student={student} mutate={mutate} variant={basicVariant} />;
    if (section === 'identity') return <Identity student={student} mutate={mutate} />;
    if (section === 'parents') return <ParentsInfo student={student} mutate={mutate} />;
    return null;
  };

  return (
    <Box padding="10px">
      <Box mt="-20px">{backTo ? <Link to={backTo}>{backButton}</Link> : backButton}</Box>

      <Box fontWeight="600" fontSize="30px" marginTop="10px">
        Editar cuenta
      </Box>

      <Text color="gray">Es importante que mantengas actualizada esta información</Text>

      <Box marginLeft="0px" marginRight="0px">
        <Box spreadOffset="right">
          <Suspense fallback={<Loading />}>
            <Tabs variant="soft-rounded" colorScheme="facebook" mt="15px">
              <TabList>
                {sections.map((section) => (
                  <Tab key={section}>{TITLES[section]}</Tab>
                ))}
              </TabList>
              <TabPanels>
                {sections.map((section) => (
                  <TabPanel key={section}>{render(section)}</TabPanel>
                ))}
              </TabPanels>
            </Tabs>
          </Suspense>
        </Box>
      </Box>
    </Box>
  );
}
